const DASH_CHARACTERS = /[-\u2013\u2014\u2011]/;

export function sanitizeMarketingText(value) {
  if (typeof value !== "string" || !DASH_CHARACTERS.test(value)) {
    return value;
  }

  // Keep the established trial CTA intact on both hydrated pages and the
  // prerendered marketing HTML. Other marketing text keeps its normal style.
  const trialDash = "\uE000";
  return value
    .replace(/30-day free trial/gi, (match) => match.replace("-", trialDash))
    .replace(/(\d)\s*[-\u2013\u2014]\s*(\d)/g, "$1 to $2")
    .replace(/\s+[\u2013\u2014-]\s+/g, ", ")
    .replace(/([A-Za-z0-9])[-\u2011]([A-Za-z0-9])/g, "$1 $2")
    .replace(/-\s*£/g, "£")
    .replace(/[\u2013\u2014]/g, ",")
    .replace(/-/g, " ")
    .replace(/\s+,/g, ",")
    .replace(/,+/g, ",")
    .replace(/\s{2,}/g, " ")
    .replaceAll(trialDash, "-");
}

export function sanitizeVisibleTextNodes(root) {
  if (!root || typeof document === "undefined") return;
  // The no-dash style is for English copy. Translated pages (<html lang="de">)
  // keep their language's hyphens: "E-Mail", "SMS-Erinnerung".
  if (!/^en\b/i.test(document.documentElement.lang || "en")) return;

  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      const parent = node.parentElement;
      if (!parent) return NodeFilter.FILTER_REJECT;
      if (parent.closest("script, style, textarea, input, code, pre")) {
        return NodeFilter.FILTER_REJECT;
      }
      return DASH_CHARACTERS.test(node.nodeValue || "")
        ? NodeFilter.FILTER_ACCEPT
        : NodeFilter.FILTER_SKIP;
    },
  });

  const nodes = [];
  while (walker.nextNode()) {
    nodes.push(walker.currentNode);
  }

  nodes.forEach((node) => {
    const sanitized = sanitizeMarketingText(node.nodeValue || "");
    if (sanitized !== node.nodeValue) node.nodeValue = sanitized;
  });
}
